"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchIris = exports.FetchIris = exports.FetchIrisActionTypes = exports.IRISActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _fluxActions = require("flux-actions");

var IRISActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_IRIS: null
}, 'iris');
exports.IRISActionTypes = IRISActionTypes;
var FetchIrisActionTypes = (0, _actions.createRequestTypes)(IRISActionTypes.FETCH_IRIS);
exports.FetchIrisActionTypes = FetchIrisActionTypes;
var FetchIris = (0, _actions.createRequestActions)(FetchIrisActionTypes);
exports.FetchIris = FetchIris;
var fetchIris = (0, _fluxActions.createAction)(IRISActionTypes.FETCH_IRIS);
exports.fetchIris = fetchIris;